export interface ServiceData {
    id: string;
    icon: string;
    image: string;
    bgImage: string;
    translationKey: string;
    budgetParam: string;
}

export const servicesData: Record<string, ServiceData> = {
    'alinhamento': {
        id: 'alignment',
        icon: 'icon-tire',
        image: '/assets/logo/services/alignment.webp',
        bgImage: '/assets/logo/services_spesific/alignement.webp',
        budgetParam: 'alinhamento',
        translationKey: 'alignment'
    },
    'teste-diagnostico': {
        id: 'diagnosticTest',
        icon: 'icon-diagnostic',
        image: '/assets/logo/services/diagnostic_test.webp',
        bgImage: '/assets/logo/services_spesific/diagnostic_test.webp',
        budgetParam: 'diagnostico',
        translationKey: 'diagnosticTest'
    },
    'revisoes-roady': {
        id: 'roadyReview',
        icon: 'icon-mechanical',
        image: '/assets/logo/services/roady_review.webp',
        bgImage: '/assets/logo/services_spesific/roady_reviews.webp',
        budgetParam: 'revisao',
        translationKey: 'roadyReview'
    },
    'amortecedores': {
        id: 'shockAbsorbers',
        icon: 'icon-tyre',
        image: '/assets/logo/services/shock_absorbers.webp',
        bgImage: '/assets/logo/services_spesific/amortecedores.webp',
        budgetParam: 'amortecedores',
        translationKey: 'shockAbsorbers'
    },
    'inspecao': {
        id: 'inspection',
        icon: 'icon-oil',
        image: '/assets/logo/services/inspection.webp',
        bgImage: '/assets/logo/services_spesific/inspection.webp',
        budgetParam: 'inspecao',
        translationKey: 'inspection'
    },
    'mecanica-geral': {
        id: 'generalMechanics',
        icon: 'icon-mechanical',
        image: '/assets/logo/services/general_mechanics.webp',
        bgImage: '/assets/logo/services_spesific/general_mechanics.webp',
        budgetParam: 'mecanica',
        translationKey: 'generalMechanics'
    },
    'servicos-oficina': {
        id: 'workshopServices',
        icon: 'icon-car-wash',
        image: '/assets/logo/services/service_pack.webp',
        bgImage: '/assets/logo/services_spesific/services_pack.webp',
        budgetParam: 'pacote',
        translationKey: 'workshopServices'
    },
    'ar-condicionado': {
        id: 'airConditioning',
        icon: 'icon-air-conditioning',
        image: '/assets/logo/services/air_conditioning.webp',
        bgImage: '/assets/logo/services_spesific/air_conditioning.webp',
        budgetParam: 'ar-condicionado',
        translationKey: 'airConditioning'
    },
    'lavagem': {
        id: 'washing',
        icon: 'icon-tools',
        image: '/assets/logo/services/washing.webp',
        bgImage: '/assets/logo/services_spesific/lavagem.webp',
        budgetParam: 'lavagem',
        translationKey: 'washing'
    },
    'restauro-farois': {
        id: 'headlightRestoration',
        icon: 'icon-headlight',
        image: '/assets/logo/services/headlight_restoration.webp',
        bgImage: '/assets/logo/services_spesific/headlight_restoration.webp',
        budgetParam: 'farois',
        translationKey: 'headlightRestoration'
    },
    'baterias': {
        id: 'batteries',
        icon: 'icon-battery',
        image: '/assets/logo/services/batteries.webp',
        bgImage: '/assets/logo/services_spesific/bateria.webp',
        budgetParam: 'baterias',
        translationKey: 'batteries'
    },
    'travoes': {
        id: 'brakes',
        icon: 'icon-breakdown',
        image: '/assets/logo/services/brakes.webp',
        bgImage: '/assets/logo/services_spesific/brakes.webp',
        budgetParam: 'travoes',
        translationKey: 'brakes'
    }
};

// Get all service slugs for routing
export const serviceRoutes = Object.keys(servicesData);

